import HiringPreferencesSettings from './HiringPreferencesSettings.page';

export default HiringPreferencesSettings;